import { render, staticRenderFns } from "./r-booster-page.vue?vue&type=template&id=e8cc523e"
import script from "./r-booster-page.vue?vue&type=script&lang=js"
export * from "./r-booster-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8cc523e')) {
      api.createRecord('e8cc523e', component.options)
    } else {
      api.reload('e8cc523e', component.options)
    }
    module.hot.accept("./r-booster-page.vue?vue&type=template&id=e8cc523e", function () {
      api.rerender('e8cc523e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/booster/r-booster-page.vue"
export default component.exports